if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"webapp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(0402|0946|1116|140|6764|814)|8((138|332|883)0|0264)|(1645|3431|4781|5318|6388)0|17548|51354|9097)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}